import { PaginatedDataDTO } from "@bottega52/commons-pagination";
import { Button, Card } from "@material-ui/core";
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import WalletIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import * as React from "react";
import { connect, ConnectedProps } from 'react-redux';
import * as CreditsActions from '../../redux/credits/credits.actions';
import { IState } from '../../redux/store';
import { ICustomerInDTO } from "../../repository/jago/model/input/ICustomerInDTO";
import { IWalletDetailedDTO } from '../../repository/jago/model/input/IWalletDetailedDTO';
import { IWalletInDTO } from "../../repository/jago/model/input/IWalletInDTO";
import { IWalletRequestParamsDTO } from "../../repository/jago/model/output/IWalletRequestParamsDTO";
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import Permission from "../Permission/Permission";
import ReduxLanguage from "../ReduxLanguage";
import WalletsList from "../Wallets/WalletsList";

const styles = createStyles({
  container: {
    display: 'flex',
    marginTop: 20,
    flexDirection: 'column',
  },
  cardContainer: {
    padding: 10,
    borderLeft: '3px solid #5AC0B1',
    minHeight: 'calc(100vh - 340px)',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    marginRight: 5,
    fontSize: 25,
  },
  title: {
    fontWeight: 'bold'
  },
});

export interface ICustomerWalletSectionState {
}

type IReduxProps = ConnectedProps<typeof connector>;

export interface ICustomerWalletSectionProps extends WithStyles<typeof styles> {
  language: string;
  wallets: PaginatedDataDTO<IWalletInDTO>;
  customer: ICustomerInDTO;
  onShowWalletDetails: (wallet: IWalletInDTO) => void;
  onOpenWalletForm: (wallet?: IWalletDetailedDTO) => void;
}

export type ComponentProps = ICustomerWalletSectionProps & IReduxProps;

class CustomerWalletSection extends React.Component<ComponentProps, ICustomerWalletSectionState> {

  public onAppenWallets(page: number) {
    const { dispatch, customer } = this.props;
    const params: IWalletRequestParamsDTO = { customerId: customer.id, page };
    dispatch<any>(CreditsActions.appendCustomerWallets(params));
  }
  
  public render() {
    const { wallets, customer, classes, onShowWalletDetails, onOpenWalletForm } = this.props;

    return (
      <div className={classes.container}>
        <Card className={classes.cardContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <WalletIcon className={classes.icon} />
              <h3 className={classes.title}>{<ReduxLanguage languageKey="credits.customerWallets" languageProps={{ customerName: customer.name }} />}</h3>
            </div>
            <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.WALLET_CREATE}>
              <Button
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: '#5AC0B1', fontSize: 11, color: 'white' }}
                onClick={() => onOpenWalletForm()}
              >
                <ReduxLanguage languageKey="forms.createNewWallet" />
              </Button>
            </Permission>
          </div>
          <WalletsList
            wallets={wallets}
            onRowClick={wallet => onShowWalletDetails(wallet)}
            onFetchMoreItems={page => this.onAppenWallets(page)}
          />
        </Card>
      </div>
    );
  }
}


function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    wallets: state.credits.wallets.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles (styles)(CustomerWalletSection as any));